import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

function Kameralar() {
  const navigate = useNavigate();
  const [kameralar, setKameralar] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- EFSANEVİ SAYFALAMA (PAGINATION) MOTORU ---
  const [mevcutSayfa, setMevcutSayfa] = useState(1);
  const sayfaBasinaUrun = 6; // Her sayfada tam 6 ürün gösterecek!

  useEffect(() => {
    const kameralariGetir = async () => {
      try {
        const { data, error } = await supabase.from('kameralar').select('*').order('olusturulma_tarihi', { ascending: false });
        if (error) throw error;
        setKameralar(data);
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    kameralariGetir();
  }, []);

  // SİHİRLİ MATEMATİK: Sadece o sayfaya ait 6 ürünü hesapla ve kes!
  const sonUrunIndex = mevcutSayfa * sayfaBasinaUrun;
  const ilkUrunIndex = sonUrunIndex - sayfaBasinaUrun;
  const gosterilecekUrunler = kameralar.slice(ilkUrunIndex, sonUrunIndex);
  
  // Toplam kaç sayfa olacağını hesapla
  const toplamSayfa = Math.ceil(kameralar.length / sayfaBasinaUrun);

  // Sayfa değiştirme fonksiyonu ve yukarı kaydırma
  const sayfaDegistir = (sayfaNumarasi) => {
    setMevcutSayfa(sayfaNumarasi);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Tıklayınca yağ gibi en başa çıkar
  };

  if (loading) return <div className="loading-spinner" style={{paddingTop: '150px', color: 'white', textAlign: 'center'}}>Yükleniyor...</div>;

  return (
    <div className="kameralar-page-square">
      <div className="kameralar-header-square">
        <h1>Güvenlik Sistemlerimiz</h1>
        <p>Yüksek teknolojiyle donatılmış VIP izleme ve koruma sistemleri.</p>
      </div>

      <div className="kamera-grid-square">
        {/* Tümünü değil, sadece kesilmiş 6 ürünü basıyoruz! */}
        {gosterilecekUrunler.map((item) => (
          <div key={item.id} className="kamera-card-square" onClick={() => navigate(`/kamera/${item.id}`)}>
            <img src={item.resimler ? item.resimler[0] : item.resim_url} alt={item.baslik} className="square-image" />
            <div className="square-overlay">
              <h3>{item.baslik}</h3>
              <div className="go-icon">↗</div>
            </div>
          </div>
        ))}
      </div>

      {/* --- LÜKS SAYFALAMA BUTONLARI (Sadece 6'dan fazla ürün varsa görünür) --- */}
      {toplamSayfa > 1 && (
        <div className="pagination-container">
          <button 
            onClick={() => sayfaDegistir(mevcutSayfa - 1)} 
            disabled={mevcutSayfa === 1}
            className="page-btn nav-btn"
          >
            &#10094; Önceki
          </button>
          
          {[...Array(toplamSayfa)].map((_, index) => (
            <button 
              key={index} 
              onClick={() => sayfaDegistir(index + 1)} 
              className={`page-btn ${mevcutSayfa === index + 1 ? 'active' : ''}`}
            >
              {index + 1}
            </button>
          ))}

          <button 
            onClick={() => sayfaDegistir(mevcutSayfa + 1)} 
            disabled={mevcutSayfa === toplamSayfa}
            className="page-btn nav-btn"
          >
            Sonraki &#10095;
          </button>
        </div>
      )}

    </div>
  );
}

export default Kameralar;